import React from 'react';
import {type RowData} from '@tanstack/react-table';
import {GenericCell, type GenericCellProps} from './GenericCell';

export interface GenericCellDynamicHeightProps<TData extends RowData>
	extends GenericCellProps<TData> {}

export const GenericCellDynamicHeight = <TData extends RowData>(
	props: GenericCellDynamicHeightProps<TData>,
) => {
	return (
		<GenericCell
			{...props}
			TypographyProps={{
				noWrap: false,
				...props.TypographyProps,
				style: {
					wordBreak: 'break-word',
					...props.TypographyProps?.style,
				},
			}}
		/>
	);
};
